<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ title }}
            <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="goToChallengeList">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-form ref="form" lazy-validation v-model="valid" class="ma-5 pa-5">
            <v-row>
                <v-col lg="9" md="9" sm="12">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field :rules="requiredRule" v-model="editedItem.name" label="Name*" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col lg="12" md="12" sm="12">
                            <v-combobox v-model="editedItem.admin" :items="challengeAdminList" label="Admin" multiple></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col lg="12" md="12" sm="12">
                            <v-combobox v-model="editedItem.fixGroupIdList" :items="groupList" label="กลุ่มแข่ง" multiple></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col lg="6" md="6" sm="12">
                            <!-- <v-text-field :rules="requiredRule" v-model="editedItem.minMemberCount" label="Mininum Member" required type="number"></v-text-field> -->
                            <v-select v-model="editedItem.minMemberCount" :items="memberMininumList" :rules="requiredRule" label="Mininum Member" required></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col lg="6" md="6" sm="12">
                            <v-text-field
                                v-model.number="editedItem.maxMember"
                                label="จำนวนคนเข้าร่วมสูงสุด (maxMember)"
                                hint="0 = ไม่จำกัดจำนวน"
                                persistent-hint
                                type="number"
                                min="0"
                                :rules="nonNegativeRule"
                            ></v-text-field>
                        </v-col>
                        <v-col lg="6" md="6" sm="12">
                            <v-text-field
                                v-model.number="editedItem.maxGroupMember"
                                label="จำนวนสมาชิกสูงสุดต่อกลุ่ม (maxGroupMember)"
                                hint="0 = ไม่จำกัดจำนวน"
                                persistent-hint
                                type="number"
                                min="0"
                                :rules="nonNegativeRule"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col lg="6" md="6" sm="12">
                            <v-combobox
                                v-model="editedItem.category"
                                :items="challengeTypeList"
                                label="ประเภทการแข่ง"
                                multiple
                                ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row v-if="editedItem.category != undefined && editedItem.category.length && editedItem.category.some(cat => cat.value === 'steps')">
                        <v-col lg="6" md="6" sm="12">
                            <v-text-field :rules="[...requiredRule, v => !v || v <= 60000 || 'Number cannot exceed 60000']" v-model="editedItem.maxStepsPerDay" label="จำนวนก้าวสูงสุดต่อวัน" required type="number"></v-text-field>
                        </v-col>
                         <v-col lg="6" md="6" sm="12">
                            <v-checkbox v-model="editedItem.excludeManualSteps" label="ไม่นับก้าวแบบ Manual"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row v-if="editedItem.category != undefined && editedItem.category.length && (editedItem.category.some(cat => cat.value === 'steps') || editedItem.category.some(cat => cat.value === 'run') || editedItem.category.some(cat => cat.value === 'weight'))">
                        <v-col lg="6" md="6" sm="12">เป้าหมายการแข่งขัน</v-col>
                    </v-row>
                    <v-row v-if="editedItem.category != undefined && editedItem.category.length && editedItem.category.some(cat => cat.value === 'steps')">
                        <v-col lg="4" md="4" sm="12">
                            <v-text-field :rules="[...requiredRule, v => !v || v > 0 || 'Number must be greater than 0']" v-model="editedItem.totalStepsGoal" label="จำนวนก้าวรวม" required type="number"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="editedItem.category != undefined && editedItem.category.length && editedItem.category.some(cat => cat.value === 'run')">
                        <v-col lg="4" md="4" sm="12">
                            <v-text-field :rules="[...requiredRule, v => !v || v > 0 || 'Number must be greater than 0']" v-model="editedItem.totalDistanceGoal" label="ระยะทางรวม" required type="number"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="editedItem.category != undefined && editedItem.category.length && editedItem.category.some(cat => cat.value === 'weight')">
                        <v-col lg="4" md="4" sm="12">
                            <v-text-field :rules="[...requiredRule, v => !v || v > 0 || 'Number must be greater than 0']" v-model="editedItem.totalWeightChangeGoal" label="ลดน้ำหนักรวม" required type="number"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col lg="4" md="4" sm="12">
                            <v-checkbox v-model="editedItem.isPrivate" label="การแข่งขันภายใน"></v-checkbox>
                        </v-col>
                        <v-col lg="2" md="2" sm="12" v-if="editedItem.isPrivate">
                            <v-text-field v-model="editedItem.challengePassword" label="PIN 6 หลัก" :rules="passwordRules" type="number"></v-text-field>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                        <v-col lg="5" md="5" sm="12">
                            <v-checkbox v-model="editedItem.isWeightChallenge" label="แข่งน้ำหนัก"></v-checkbox>
                        </v-col>
                    </v-row> -->
                    <v-row>
                        <v-col lg="6" md="6" sm="12">
                            <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :rules="requiredRule" required v-model="computedDateFormattedStartDate" label="Start Date*" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                                </template>
                                <v-date-picker :rules="requiredRule" v-model="editedItem.startDate" no-title required @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col lg="6" md="6" sm="12">
                            <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :rules="requiredRule" required v-model="computedDateFormattedEndDate" label="End Date*" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                                </template>
                                <v-date-picker :rules="requiredRule" v-model="editedItem.endDate" no-title required @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea :rules="requiredRule" v-model="editedItem.details" label="รางวัล*" required>
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field :rules="websiteRule" v-model="editedItem.website" label="Website*">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="end">
                        <v-btn color="blue darken-1" text @click="goToChallengeList"> Cancel </v-btn>
                        <v-btn v-if="this.id" color="blue darken-1" text @click="submit">
                            Update
                        </v-btn>
                        <v-btn v-else color="blue darken-1" text @click="submit">
                            Add
                        </v-btn>
                    </v-row>
                </v-col>
                <v-col lg="3" md="3" sm="12" v-if="this.id">
                    <v-row>
                        <v-col cols="12" v-if="editedItem.coverImageUrl" class="d-flex justify-center">
                            <v-img :lazy-src="editedItem.coverImageUrl" max-height="150" max-width="250" :src="editedItem.coverImageUrl" aspect-ratio="1"></v-img>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input accept="image/*" label="Cover Image" @change="previewImage"></v-file-input>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
// import "firebase/compat/storage";
import {
    getStorage,
    ref,
    uploadBytesResumable,
    getDownloadURL
} from "firebase/storage";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getChallengeInfoById from "../data/getChallengeInfoById";
import setChallengeInfo from "../data/setChallengeInfo";
import setNewChallenge from "../data/setNewChallenge";
import getUserList from '../data/getUserList';
import getGroupList from '../data/getGroupList';
import resizeImage from "../utils/resizeImage";
export default {
    name: 'ChallengeForm',
    metaInfo: {
        title: 'Challenge Form'
    },
    data() {
        return {
            editedItem: {
                id: "",
                name: "",
                startDate: "",
                endDate: "",
                admin: [],
                fixGroupIdList: [],
                details: "",
                website: "",
                isPrivate: false,
                isWeightChallenge: true,
                minMemberCount: 0,
                maxMember: 0,
                maxGroupMember: 0,
                coverImageUrl: '',
                maxStepsPerDay: 60000,
                totalStepsGoal: 0,
                totalDistanceGoal: 0,
                totalWeightChangeGoal: 0
            },
            defaultItem: {
                id: "",
                name: "",
                startDate: "",
                endDate: "",
                details: "",
                website: "",
                isPrivate: false,
                isWeightChallenge: true,
                minMemberCount: 0,
                maxMember: 0,
                maxGroupMember: 0,
                coverImageUrl: '',
                maxStepsPerDay: 60000,
                totalStepsGoal: 0,
                totalDistanceGoal: 0,
                totalWeightChangeGoal: 0
            },
            menu1: false,
            menu2: false,
            challengeAdminList: [],
            groupList: [],
            //to validate from
            valid: false,
            requiredRule: [
                v => !!v
            ],
            nonNegativeRule: [
                v => v === '' || v === null || v === undefined || Number(v) >= 0 || "ต้องมีค่าตั้งแต่ 0 ขึ้นไป"
            ],
            passwordRules: [
                (v) => !!v || "Password is required",
                (v) => (v && v.length == 6) || "6-digit number",
            ],
            websiteRule: [
                (value) => !!value || "Required.",
                (value) => this.isURL(value) || "URL is not valid",
            ],
            dialog: false,
            title: "Add new challenge",
            uploadValue: 0,
            imageData: '',
            loading: false,
            memberMininumList: [{
                    value: "1",
                    text: "แข่งแบบบุคคล"
                },
                {
                    value: "2",
                    text: "กลุ่ม 2 คนขึ้นไป"
                },
                {
                    value: "3",
                    text: "กลุ่ม 3 คนขึ้นไป"
                },
                {
                    value: "4",
                    text: "กลุ่ม 4 คนขึ้นไป"
                },
                {
                    value: "5",
                    text: "กลุ่ม 5 คนขึ้นไป"
                },
                {
                    value: "6",
                    text: "กลุ่ม 6 คนขึ้นไป"
                },
                {
                    value: "7",
                    text: "กลุ่ม 7 คนขึ้นไป"
                },
                {
                    value: "8",
                    text: "กลุ่ม 8 คนขึ้นไป"
                },
                {
                    value: "9",
                    text: "กลุ่ม 9 คนขึ้นไป"
                },
                {
                    value: "10",
                    text: "กลุ่ม 10 คนขึ้นไป"
                }
            ],
            challengeTypeList: [
                {
                    value: "healthpoint",
                    text: "คะแนน"
                },
                {
                    value: "steps",
                    text: "ก้าวเดิน"
                },
                {
                    value: "run",
                    text: "วิ่ง(km)"
                },
                {
                    value: "workout",
                    text: "ออกกำลัง(นาที)"
                },
                {
                    value: "weight",
                    text: "น้ำหนัก"
                },
                {
                    value: "food",
                    text: "ผักผลไม้"
                }
            ]
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
        computedDateFormattedStartDate() {
            return this.formatDate(this.editedItem.startDate);
        },
        computedDateFormattedEndDate() {
            return this.formatDate(this.editedItem.endDate);
        },
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isChallengeAdmin) {
                (async () => {
                    //get admin list
                    this.challengeAdminList = await getUserList('getChallengeAdminUser', this.loggedInUserId);
                    let adminHash = [];
                    if (this.challengeAdminList.length) {
                        this.challengeAdminList.forEach((v) => {
                            adminHash[v.value] = v.text;
                        });
                    }

                    //get group list
                    if( this.isChallengeAdmin ){
                        this.groupList = await getGroupList(this.loggedInUserId);
                    }
                    else if( this.isSuperAdmin ){
                        this.groupList = await getGroupList();
                    }
                    let groupHash = [];
                    if( this.groupList.length ){
                        this.groupList.forEach((v) => {
                            groupHash[v.value] = v.text;
                        });
                    }
                    //get challenge info
                    if (this.id) {
                        this.editedItem = await getChallengeInfoById(this.id);
                        //reset format for support datepicker
                        this.editedItem.startDate = this.editedItem.startDateDatepicker;
                        this.editedItem.endDate = this.editedItem.endDateDatepicker;

                        //set page title
                        const editAdmin = [];
                        if (this.editedItem.admin != undefined && this.editedItem.admin.length) {
                            this.editedItem.admin.forEach((v) => {
                                if (adminHash[v] != undefined) {
                                    editAdmin.push({
                                        'value': v,
                                        'text': adminHash[v]
                                    });
                                }
                            });
                        }
                        this.editedItem.admin = editAdmin;

                        const editFixGroupIdList = [];
                        if( this.editedItem.fixGroupIdList != undefined && this.editedItem.fixGroupIdList.length ){
                            this.editedItem.fixGroupIdList.forEach((v) => {
                                editFixGroupIdList.push({
                                    'value': v,
                                    'text': groupHash[v]
                                });
                            });
                        }
                        this.editedItem.fixGroupIdList = editFixGroupIdList;


                        this.editedItem.minMemberCount = this.editedItem.minMemberCount.toString();
                        this.editedItem.maxMember = this.editedItem.maxMember !== undefined ? this.editedItem.maxMember : 0;
                        this.editedItem.maxGroupMember = this.editedItem.maxGroupMember !== undefined ? this.editedItem.maxGroupMember : 0;
                        this.title = 'Edit Challenge';

                        let categoryHash = [];
                        if (this.challengeTypeList.length) {
                            this.challengeTypeList.forEach((v) => {
                                categoryHash[v.value] = v.text;
                            });
                        }
                        let editCategory = [];
                        let isSetWeight = 0;
                        if (this.editedItem.category != undefined && this.editedItem.category.length) {
                            this.editedItem.category.forEach((v) => {
                                if (categoryHash[v] != undefined) {
                                    if( v == 'weight' ){
                                        isSetWeight = 1;
                                    }
                                    editCategory.push({
                                        'value': v,
                                        'text': categoryHash[v]
                                    });
                                }
                            });
                        }

                        if( !isSetWeight && this.editedItem.isWeightChallenge != undefined && this.editedItem.isWeightChallenge ){
                            editCategory.push({
                                'value': 'weight',
                                'text': categoryHash['weight']
                            });
                        }

                        this.editedItem.category = editCategory;
                    }
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        isURL(str) {
            let url;

            try {
                url = new URL(str);
            } catch (_) {
                return false;
            }

            return url.protocol === "http:" || url.protocol === "https:";
        },
        submit() {
            (async () => {
                //to validate from before submit
                await this.$refs.form.validate();

                if (this.valid) {
                    (async () => {
                        const admin = [];
                        if (this.editedItem.admin.length) {
                            this.editedItem.admin.forEach((item) => {
                                admin.push(item.value);
                            });
                        }

                        const group = [];
                        if( this.editedItem.fixGroupIdList != undefined && this.editedItem.fixGroupIdList.length ){
                            this.editedItem.fixGroupIdList.forEach((item) => {
                                group.push(item.value);
                            });
                        }

                        const category = [];
                        if (this.editedItem.category.length) {
                            this.editedItem.category.forEach((item) => {
                                category.push(item.value);
                            });

                            if( this.editedItem.category.some(cat => cat.value === 'steps') ){
                                this.editedItem.maxStepsPerDay = this.editedItem.maxStepsPerDay * 1;
                            }

                            if( this.editedItem.category.some(cat => cat.value === 'steps') ){
                                this.editedItem.totalStepsGoal = this.editedItem.totalStepsGoal * 1;
                            }
                            if( this.editedItem.category.some(cat => cat.value === 'run') ){
                                this.editedItem.totalDistanceGoal = this.editedItem.totalDistanceGoal * 1;
                            }
                            if( this.editedItem.category.some(cat => cat.value === 'weight') ){
                                this.editedItem.totalWeightChangeGoal = this.editedItem.totalWeightChangeGoal * 1;
                            }
                        }
                        
                        this.editedItem.isWeightChallenge = false;
                        if( category.includes('weight') ){
                            this.editedItem.isWeightChallenge = true;
                        }

                        let isIndividual = true;
                        if (this.editedItem.minMemberCount > 1) {
                            isIndividual = false;
                        }
                        if (this.id) {
                            await setChallengeInfo(this.id, {
                                name: this.editedItem.name,
                                startDate: new Date(this.editedItem.startDate + ' 00:00:00'),
                                endDate: new Date(this.editedItem.endDate + ' 23:59:59'),
                                details: this.editedItem.details || '',
                                website: this.editedItem.website || '',
                                admin: admin,
                                fixGroupIdList: group,
                                excludeManualSteps: this.editedItem.excludeManualSteps || false,
                                isPrivate: this.editedItem.isPrivate || false,
                                isWeightChallenge: this.editedItem.isWeightChallenge || false,
                                category: category,
                                minMemberCount: (this.editedItem.minMemberCount * 1),
                                maxMember: Math.max(0, parseInt(this.editedItem.maxMember, 10) || 0),
                                maxGroupMember: Math.max(0, parseInt(this.editedItem.maxGroupMember, 10) || 0),
                                coverImageUrl: this.editedItem.coverImageUrl || '',
                                challengePassword: this.editedItem.isPrivate ? this.editedItem.challengePassword : '',
                                isIndividual: isIndividual,
                                maxStepsPerDay: this.editedItem.maxStepsPerDay || 60000,
                                totalStepsGoal: this.editedItem.totalStepsGoal || 0,
                                totalDistanceGoal: this.editedItem.totalDistanceGoal || 0,
                                totalWeightChangeGoal: this.editedItem.totalWeightChangeGoal || 0
                            });
                        } else {
                            await setNewChallenge({
                                name: this.editedItem.name,
                                createdDate: new Date(),
                                startDate: new Date(this.editedItem.startDate + ' 00:00:00'),
                                endDate: new Date(this.editedItem.endDate + ' 23:59:59'),
                                details: this.editedItem.details,
                                website: this.editedItem.website,
                                owner: this.loggedInUserId,
                                admin: admin,
                                fixGroupIdList: group,
                                excludeManualSteps: this.editedItem.excludeManualSteps || false,
                                isPrivate: this.editedItem.isPrivate || false,
                                isWeightChallenge: this.editedItem.isWeightChallenge || false,
                                category: category,
                                minMemberCount: (this.editedItem.minMemberCount * 1),
                                maxMember: Math.max(0, parseInt(this.editedItem.maxMember, 10) || 0),
                                maxGroupMember: Math.max(0, parseInt(this.editedItem.maxGroupMember, 10) || 0),
                                coverImageUrl: this.editedItem.coverImageUrl,
                                challengePassword: this.editedItem.isPrivate ? this.editedItem.challengePassword : '',
                                isIndividual: isIndividual,
                                maxStepsPerDay: this.editedItem.maxStepsPerDay || 60000,
                                totalStepsGoal: this.editedItem.totalStepsGoal || 0,
                                totalDistanceGoal: this.editedItem.totalDistanceGoal || 0,
                                totalWeightChangeGoal: this.editedItem.totalWeightChangeGoal || 0
                            });
                        }

                        setTimeout(() => {
                            this.dialog = true;
                        }, "3000");
                    })();
                }
            })();
        },
        async previewImage(File) {
            if (!File) return;
            this.loading = true;
            this.uploadValue = 0;
            this.editedItem.coverImageUrl = '';
            try {
                this.imageData = await resizeImage(File, 500, 500, 0.8);
            } catch (err) {
                console.error("Image resize error", err);
                this.imageData = File;
            }
            this.onUpload();
        },
        onUpload() {
            this.editedItem.coverImageUrl = '';
            //??? storeage path /competition_images/ID/cover.jpg

            const storage = getStorage();

            // Create the file metadata
            /** @type {any} */
            const metadata = {
                contentType: 'image/jpeg'
            };

            // Upload file and metadata to the object 'images/mountains.jpg'
            const storageRef = ref(storage, 'competition_images/' + this.id + '/cover.jpg');
            const uploadTask = uploadBytesResumable(storageRef, this.imageData, metadata);

            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on('state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    this.uploadValue = progress;
                    switch (snapshot.state) {
                        case 'paused':
                            console.log('Upload is paused');
                            break;
                        case 'running':
                            console.log('Upload is running');
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                            // User doesn't have permission to access the object
                            break;
                        case 'storage/canceled':
                            // User canceled the upload
                            break;

                            // ...

                        case 'storage/unknown':
                            // Unknown error occurred, inspect error.serverResponse
                            break;
                    }
                },
                () => {
                    // Upload completed successfully, now we can get the download URL
                    getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
                        this.editedItem.coverImageUrl = downloadURL;
                        await setChallengeInfo(this.id, {
                            coverImageUrl: this.editedItem.coverImageUrl
                        });
                        this.loading = false;
                    });
                }
            );
        },
        close() {
            this.dialog = false;
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToChallengeList() {
            this.$router.push(`/challenge`);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        }
    },
};
</script>
